<div class="ui-g loyality-params" *ngIf="render.datatable">

  <div class="ui-g-12">
    <app-kontable #table
                  title="{{ 'loyalty.params' | translate }}"
                  [columns]="['id', 'description', 'param_code',
                  { field: 'param_group', title: 'params.param_group', filterType: selectFilter, filterOptions: {values: listParamGroup} },
                  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: customFilter, filterTemplate: stateFilter}]"
                  [titles]="['common.id', 'params.description', 'params.param_code']"
                  [service]="paramService"
                  [paginationType]="serverPagination"
                  [showInfoButton]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [servicePermissions]="paramPermissions"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  (onAdd)="addNew()"
                  (onEdit)="edit($event)"
                  (onRecover)="recover($event)"
                  (onRemove)="remove($event)">

                  <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
                    <span *ngIf="row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
                  </ng-template>

                  <ng-template #stateFilter data-testid="stateFilter" let-col>
                    <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" [(ngModel)]="table.filter.search[col.field]"></p-dropdown>
                  </ng-template>

    </app-kontable>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-params/loyalty-params.component.html